<template>
  <div>

    <v-container>
      <v-row class="ma-0">
        <v-col cols="6" class="text-right">
          <span class="headline text-center">Kegiatan Tahun Anggaran </span>
        </v-col>
        <v-col cols="2">
          <v-select
            :items="itemsTahunAnggaran"
            label="Tahun Anggaran"
            v-model="tahunAnggaranSel"
            single-line
            dense
            class="headline"
            @change="tahunAnggaranSelChange"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <p class="headline text-center">{{ divisiText }}</p>
        </v-col>
      </v-row>
          
      <v-row class="mx-2">
        <v-col cols="2">
          <!-- ADD BUTTON -->
          <!-- <v-btn dark color="green" @click="openForm(null)">Tambah</v-btn>    -->
        </v-col>   
        <v-col cols="4">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-col>      
        <v-col cols="2">
          <v-text-field class="rightalign" v-model="getFormTotalKegiatan" label="Total Pagu Kegiatan: " outlined readonly />
        </v-col>
        <v-col cols="2">
          <v-text-field class="rightalign" v-model="getFormTotalKegiatanTerpakai" label="Total Pagu Terpakai: " outlined readonly />
        </v-col> 
        <v-col cols="2">
          <v-text-field class="rightalign" v-model="getFormTotalKegiatanSisa" label="Total Sisa Pagu: " outlined readonly />
        </v-col> 
      </v-row>
      
      <v-row class="mt-0">
          <v-col cols="10">
          </v-col>
          <v-col cols="2">
              <v-btn color="cyan" dark @click="refreshPage()">Refresh</v-btn>
          </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12">
          <!-- Data Table -->
          <v-data-table
            class="elevation-1 ma-2"
            :headers="table.headers"
            :items="table.items"
            :items-per-page="10"
            :single-select="true"
            :search="search"
            item-key="id"
            no-data-text="Belum ada data !"
            height="400"
            fixed-header
          >
            <!-- <template v-slot:item.programId="{item}">
                {{ getProgram(item.programId) }}
            </template>

            <template v-slot:item.kode="{item}">
                {{ item.kode }} - {{ item.nama }}
            </template> -->

            <template v-slot:item.ppk="{item}">
                {{ getPPKText(item.ppk) }}
            </template>

            <template v-slot:item.pagu="{item}">
              <div class="text-right">
                {{ getNumberSep(item.pagu) }}
              </div>
            </template>

            <template v-slot:item.paguTerpakai="{item}">
              <div class="text-right">
                {{ getNumberSep(item.paguTerpakai) }}
              </div>
            </template>

            <template v-slot:item.paguSisa="{item}">
              <div class="text-right">
                {{ getNumberSep(item.pagu-item.paguTerpakai) }}
              </div>
            </template>

            <template v-slot:item.status="{item}">
              <v-chip :color="getColorStatus(item.status)">
                {{ getStatus(item.status) }}
              </v-chip>
            </template>

            <template v-slot:item.actions="{item}">
                  <v-btn color="cyan" small icon @click="openForm(item, false, false)" v-if="item.status === 'N'"> <v-icon small class="mr-2">mdi-pencil</v-icon> </v-btn>
                  <v-btn color="cyan" dark  @click="openForm(item, true, true)" v-if="item.status === 'N'">App/Rej</v-btn>
                  <v-btn color="blue" small icon @click="openForm(item, false, true)" v-if="item.status !== 'N'"> <v-icon small>mdi-file-find</v-icon> </v-btn>
              </template>

          </v-data-table>
        </v-col>
      </v-row>
      <v-row class="mx-2">
        <v-col cols="12">
          <!-- ADD BUTTON -->
          <v-btn dark color="orange" small @click.prevent="exportXls">Export XLS</v-btn>   
          <v-btn class="mx-2" dark color="red" small @click.prevent="exportPdf">Export PDF</v-btn> 
        </v-col>   
      </v-row>


      <!-- DELETE ALERT -->
      <v-dialog v-model="form.isDeleting" max-width="600" persistent>  
        <v-alert type="error">
          <v-row align="center">
            <v-col class="grow">Anda yakin ingin menghapus data kegiatan ini? </v-col>
          </v-row>
          <v-row>
            <v-col class="shrink" @click="submitForm"> <v-btn>Yes</v-btn> </v-col>
            <v-col class="shrink" @click="closeForm"> <v-btn>No</v-btn> </v-col>
          </v-row>
        </v-alert>
      </v-dialog>


    </v-container>

    <!-- Dialog Program -->
    <v-dialog v-model="form.isShowing" persistent max-width="800px">
      <v-card>
        <v-card-title class="blue lighten-1 white--text">
          <span class="headline">Form Kegiatan</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="frmKegiatan" v-model="valid">
            <v-container>
              <v-row v-if="form.isView">
                <v-col cols="6">
                  <v-text-field :value="getDivisi(form.kegiatan.divisi)" label="Divisi" type="text" outlined :readonly="form.isView"/>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.kegiatan.kode" label="Kode Kegiatan" type="text" outlined :readonly="form.isView"/>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-autocomplete
                    v-model="program.selected"
                    :items="program.list"
                    label="Kode - Nama Program"
                    placeholder="Pilih program"
                    return-object
                    filled
                    @change="programChange"
                    :readonly="form.isView"
                    >
                  </v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.kegiatan.nama" label="Nama Kegiatan" type="text" outlined :readonly="form.isView"/>  
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-select
                    :items="listManDivisi"
                    label="PPK"
                    v-model="form.kegiatan.mandivisi"
                    outlined
                    readonly
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.kegiatan.volume" label="Volume" type="number" outlined :readonly="form.isView"/>  
                  <!-- <v-text-field v-model="form.kegiatan.pagu" label="Pagu" type="number" outlined />   -->
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <!-- <v-text-field v-model="form.kegiatan.ppk" label="PPK" type="text" outlined readonly/>   -->
                  <v-select
                    :items="listPPK"
                    label="Directorat"
                    v-model="form.kegiatan.ppk"
                    outlined
                    readonly
                  ></v-select>
                </v-col>
              </v-row>
              <!-- DANA -->
                <v-row class="grey lighten-2">
                    <v-col> <v-subheader class="title">DANA</v-subheader> </v-col>
                </v-row>
                <v-row v-for="(dana, i) in formListPendanaan" :key="'dana' + i" align="center">
                    <v-col cols="2"> <v-autocomplete v-model="formListPendanaan[i].sumberDana" :items="listSumberDana" item-text="text" item-value="value" item-key="value" label="Sumber Dana" :readonly="form.isView"/> </v-col>
                    <v-col> <v-text-field v-model="formListPendanaan[i].asalDana" label="Asal Dana" :readonly="form.isView"/> </v-col>
                    <!-- <v-col> <v-text-field v-model="formListPendanaan[i].mak" label="MAK" :readonly="form.isView"/> </v-col> -->
                    <v-col> 
                      <v-autocomplete v-model="formListPendanaan[i].mak" :items="listCOA" item-value="id" label="COA" :readonly="form.isView">
                        <template v-slot:selection="data">
                            <!-- HTML that describe how select should render selected items -->
                            {{ data.item.kode }} - {{ data.item.nama }}
                          </template>
                          <template v-slot:item="data">
                            <!-- HTML that describe how select should render items when the select is open -->
                            {{ data.item.kode }} - {{ data.item.nama }}
                          </template>
                      </v-autocomplete> 
                    </v-col>
                    <v-col> <text-field-rupiah v-model="formListPendanaan[i].pagu" label="Pagu" @input="updateTotalPagu" :readonly="form.isView"/> </v-col>
                    <v-col cols="1"> <v-btn class="mx-2" color="red" fab x-small @click="removeSumberDana($event, i)" v-if="!form.isView"> <v-icon>mdi-minus</v-icon> </v-btn> </v-col>
                </v-row>
                <v-row>
                    <v-col> <v-btn class="mx-2" color="cyan" @click="addSumberDana" v-if="!form.isView">Tambah</v-btn> </v-col>
                    <v-col> <v-text-field v-model="getFormTotalPagu" label="Total Pagu" prefix="Rp" readonly outlined /> </v-col>
                    <!-- <v-col> <v-text-field v-model="form.totalPagu" label="Total Pagu" readonly outlined /> </v-col> -->
                    
                </v-row>


                <!-- PENGADAAN -->
                <v-row class="grey lighten-2">
                    <v-col> <v-subheader class="title">PENGADAAN</v-subheader> </v-col>
                </v-row>
                <v-row>
                    <v-col> <v-autocomplete v-model="form.kegiatan.jenisPengadaan" :items="listJenisPengadaan" item-text="text" item-value="value" item-key="value" label="Jenis Pengadaan" :readonly="form.isView"/> </v-col>
                    <!-- <v-col> <v-autocomplete v-model="form.kegiatan.metodePemilihan" :items="listMetodePemilihan" item-text="text" item-value="value" item-key="value" label="Metode Pemilihan" :readonly="form.isView"/> </v-col> -->
                </v-row>
                <!-- <v-row>
                    <v-col cols="4"> <v-label>Pemanfaatan Barang/Jasa</v-label> </v-col>
                    <v-col> <component-text-date-picker :date-value="form.kegiatan.pemanfaatanBarangJasaAwal" label="Awal" type="month" @changed="form.kegiatan.pemanfaatanBarangJasaAwal = $event" /> </v-col>
                    <v-col> <component-text-date-picker :date-value="form.kegiatan.pemanfaatanBarangJasaAkhir" label="Akhir" type="month" @changed="form.kegiatan.pemanfaatanBarangJasaAkhir = $event" /> </v-col>
                </v-row> -->
                <v-row>
                    <v-col cols="4"> <v-label>Pelaksanaan Kontrak</v-label> </v-col>
                    <v-col> <component-text-date-picker :date-value="form.kegiatan.pelaksanaanKontrakAwal" label="Awal" type="month" @changed="form.kegiatan.pelaksanaanKontrakAwal = $event" :readonly="form.isView"/> </v-col>
                    <v-col> <component-text-date-picker :date-value="form.kegiatan.pelaksanaanKontrakAkhir" label="Akhir" type="month" @changed="form.kegiatan.pelaksanaanKontrakAkhir = $event" :readonly="form.isView"/> </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4"> <v-label>Pemilihan Penyedia</v-label> </v-col>
                    <v-col> <component-text-date-picker :date-value="form.kegiatan.pelaksanaanPemilihanPenyediaAwal" label="Awal" type="month" @changed="form.kegiatan.pelaksanaanPemilihanPenyediaAwal = $event" :readonly="form.isView"/> </v-col>
                    <v-col> <component-text-date-picker :date-value="form.kegiatan.pelaksanaanPemilihanPenyediaAkhir" label="Akhir" type="month" @changed="form.kegiatan.pelaksanaanPemilihanPenyediaAkhir = $event" :readonly="form.isView"/> </v-col>
                </v-row>
                <template v-if="!form.isEditing || (form.isView && form.kegiatan.status === 'RM')">
                  <v-row class="grey lighten-2">
                    <v-col> <v-subheader class="title">Alasan Reject</v-subheader> </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6"> <v-textarea v-model="form.kegiatan.manAlasan" label="Alasan Reject" counter="500" :readonly="form.kegiatan.status==='RM'"/> </v-col>
                  </v-row>                
                </template>
                <br>     
                <template v-if="form.kegiatan.tglBuat">
                  - Dibuat Oleh: {{ form.kegiatan.userBuat }} - {{ getDateFormattedDatefns(form.kegiatan.tglBuat) }}
                </template>
                <br>
                <template v-if="form.kegiatan.manTglApproval">
                  - {{ getStatus(form.kegiatan.status) }}: {{ form.kegiatan.manUser }} - {{ getDateFormattedDatefns(form.kegiatan.manTglApproval) }}
                </template>
                <br>
                <template v-if="form.kegiatan.ppkTglApproval">
                  - {{ getStatus(form.kegiatan.statusPPK) }}: {{ form.kegiatan.ppkUser }} - {{ getDateFormattedDatefns(form.kegiatan.ppkTglApproval) }}
                </template>
                <br>
                <template v-if="form.kegiatan.ulpTglproses">
                  - {{ getStatus(form.kegiatan.statusULP) }}: {{ form.kegiatan.ulpUser }} - {{ getDateFormattedDatefns(form.kegiatan.ulpTglproses) }}
                </template>
                <br>
                <template v-if="form.kegiatan.paTglApproval">
                  - {{ getStatus(form.kegiatan.statusPA) }}: {{ form.kegiatan.paUser }} - {{ getDateFormattedDatefns(form.kegiatan.paTglApproval) }}
                </template>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn dark color="orange darken-1" @click="closeForm">Tutup</v-btn>
          <v-btn v-if="form.isEditing && !form.isView" dark color="green accent-3" @click="submitForm">Simpan</v-btn>
          <v-btn v-if="!form.isEditing" dark color="green accent-3" @click="Approve(true)">Approve</v-btn>
          <v-btn v-if="!form.isEditing" dark color="red darken-1" @click="Approve(false)">Reject</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- Notification -->
    <v-snackbar
        v-model="notification.show"
        :color="notification.color"
        :top="true"
        :right="true"
        :timeout=3000
    >
        {{notification.text}}
    </v-snackbar>

    <v-dialog v-model="submitting" persistent max-width="300px">
        <v-card dark>
            <v-card-title>Sedang diproses</v-card-title>
            <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
        </v-card>
    </v-dialog>


  </div>
</template>

<script>
const axios = require('axios').default;
const apiUrl = process.env.VUE_APP_ROOT_API
import TextFieldDatePicker from "@/components/TextFieldDatePicker.vue"
import TextFieldRupiah from "./../../components/TextFieldRupiah.vue"
import { rules } from './../../lib/rules'
import { getValueItem, itemsDivisi, tahunAnggaran, getPPKValue, getListPPK, sumberDana } from './../../lib/viewLib'
import { itemsMetodePemilihan, itemsJenisPengadaan } from './../../lib/viewTenderLib'
import { format } from 'date-fns'


export default {
  components: {
      "component-text-date-picker": TextFieldDatePicker,
      "text-field-rupiah": TextFieldRupiah
    },

  data () {
    return {
      itemsTahunAnggaran: tahunAnggaran,
      tahunAnggaranSel: 2021,
      rules: {
        required: rules.required
      },
      divisi: this.$store.getters.userInfo.divisi,
      search: '',
      valid: true,

      // Table
      table: {
        headers: [
          { text: "Program", value: "program", class: "subtitle-2 font-weight-black" },
          { text: "Kegiatan", value: "keg", class: "subtitle-2 font-weight-black" },
          { text: "Divisi/Unit", value: "div", class: "subtitle-2 font-weight-black" },
          { text: "PPK", value: "mandivisitext", class: "subtitle-2 font-weight-black" },
          { text: "Directorat", value: "ppk", class: "subtitle-2 font-weight-black" },
          { text: "Nilai Pagu", value: "pagu", align: 'end', class: "subtitle-2 font-weight-black" },
          { text: "Pagu Terpakai", value: "paguTerpakai", align: 'end', class: "subtitle-2 font-weight-black" },
          { text: "Sisa Pagu", value: "paguSisa", align: 'end', class: "subtitle-2 font-weight-black" },
          { text: "Status", value: "status", class: "subtitle-2 font-weight-black" },
          { text: "Actions", value: "actions", sortable: false, class: "subtitle-2 font-weight-black" }
        ],
        items: [],
      },

      // Program
      program: {
          list: [],
          selected: { text: "", value: "", kode: "" },
      },

      listSumberDana: [],
      listJenisPengadaan: [],
      listMetodePemilihan: [],
      listPPK: [],
      listCOA: [],
      listManDivisi: [],

      // Form data
      form: {
        kegiatan: {
          id: "",
          kode: "",
          kodeRUP: "",
          nama: "",
          pagu: 0,
          paguTerpakai: 0,
          tahunAnggaran: 0,
          divisi: "",
          ppk: "",
          mandivisi:"",
          volume: 0,
          pelaksanaanKontrakAwal: null,
          pelaksanaanKontrakAkhir: null,
          pelaksanaanPemilihanPenyediaAwal: null,
          pelaksanaanPemilihanPenyediaAkhir: null,
          programId: 0,   
          jenisPengadaan: "",
          metodePemilihan: "",   
          listPendanaan: [],       
          userBuat: "",   
          tglBuat: "",   
          manUser: "",   
          status: "",
          manTglApproval: "",   
          ppkUser: "",   
          statusPPK: "",   
          ppkTglApproval: "",   
          ulpUser: "",   
          statusULP: "",   
          ulpTglproses: "",   
          paUser: "",
          statusPA: "",
          paTglApproval: ""
        },
        isShowing: false,
        isEditing: false,
        isDeleting: false,
        isView: false,
      },

      formListPendanaan: [ { sumberDana: "", asalDana: "", mak: "", pagu: 0 } ],

      // Notification
      notification: {
        show: false,
        color: "",
        text: ""
      },

      currNumber: 0,
      submitting: false,
      userId: this.$store.getters.userInfo.userId
    }
  },

  computed: {
    thnAggaran: function() {
      return this.$store.getters.tahunAnggaran
    },
    divisiText: function() {
      return getValueItem(itemsDivisi, this.divisi)
    },
    getFormTotalPagu: function() {
      return this.getNumberSep(this.form.kegiatan.pagu)
    },
    getFormTotalKegiatan: function() {
      let total = 0
      this.table.items.forEach(el => {
        total = total + el.pagu
      })
      return this.getNumberSep(total)
    },
    getFormTotalKegiatanTerpakai: function() {
      let total = 0
      this.table.items.forEach(el => {
        total = total + el.paguTerpakai
      })
      return this.getNumberSep(total)
    },
    getFormTotalKegiatanSisa: function() {
      let total = 0
      this.table.items.forEach(el => {
        total = total + el.pagu - el.paguTerpakai
      })
      return this.getNumberSep(total)
    }
  },

  async created() {      
    await this.getManDivisi()
    this.tahunAnggaranSel = this.$store.getters.tahunAnggaran    
    await this.getProgramList()
    await this.getData()
    await this.getCOA()
    this.listPPK = getListPPK()
    this.form.kegiatan.ppk = getPPKValue(this.divisi)
    this.form.kegiatan.divisi = this.divisi
    this.form.kegiatan.status = 'N'
    this.form.kegiatan.tahunAnggaran = this.tahunAnggaranSel
    this.listSumberDana = sumberDana
    this.listJenisPengadaan = itemsJenisPengadaan
    this.listMetodePemilihan = itemsMetodePemilihan    
  },

  methods: {
    refreshPage() {
        this.$router.push({ name: 'TemporaryPage', params: { link: '/rup/kegiatan/sup'} }); 
    },
    getPPKText(val) {
      console.log("PPK value: ", val);
      const found = this.listPPK.find(element => { return element.value === val; });
      return found ? found.text : "";
    },
    getDivisi(divisi) {
      return getValueItem(itemsDivisi, divisi)
    },
    getManDivisi() {

      this.listManDivisi = []

      axios.get(`${apiUrl}/api/rup/mandivisi/${this.divisi}`)
      .then( (response) => { 
        var manDivisi = response.data

        if (manDivisi && manDivisi.length > 0) { 
          manDivisi.forEach(element => {
            this.listManDivisi.push({
                text: `${element.nama}`,
                value: element.divisi,
            });
          });
        }


      })
      .catch( (error) => { 
          console.error(error); 
      });
    },
    getData() {
      axios.get(`${apiUrl}/api/rup/kegiatan/div/${this.divisi}/tahun/${this.tahunAnggaranSel}`)
      .then( (response) => { 
        let listKeg = response.data
        Promise.all(
          listKeg.map(async (el) => {
            el.program = await this.getProgram(el.programId);
            el.keg = `${el.kode} - ${el.nama}`;
            el.div = `${el.divisi} - ${this.getDivisi(el.divisi)}`;
            el.mandivisi = el.divisi;
            el.mandivisitext = this.getMandivisiText(el.divisi);
          })
        ).then(() => {
          this.table.items = listKeg;
        });
        
      })
      .catch( (error) => { 
          console.error(error); 
      });
    },
    getMandivisiText(divisi) {
      return this.listManDivisi.find( el => el.value == divisi).text;
    },
    async getProgramList() {
      this.program.list = [];
      try {
        const response = await axios.get(`${apiUrl}/api/rup/program/kode/nama/${this.tahunAnggaranSel}`);
        const programs = response.data;
        if (programs && programs.length > 0) {
          programs.forEach(element => {
            this.program.list.push({
              text: `${element.kode} - ${element.nama}`,
              value: element.id
            });
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    getCOA() {
      this.listCOA = []
      // get program items
      axios.get(`${apiUrl}/api/rup/coa`)
      .then( (response) => {
        this.listCOA = response.data
      })
      .catch( (error) => {
          console.error(error);
      });
    },
    generateKode() {
      const div = this.form.kegiatan.divisi
      console.log(div)
      const coa = this.listCOA.find(el => el.id == this.formListPendanaan[0].mak).kode
      console.log(coa)
      const jp = this.listJenisPengadaan.find(el => el.value === this.form.kegiatan.jenisPengadaan).kode
      console.log(jp)
      // const kegCode = this.kegiatanSelect.kode
      const pro = this.program.list.find(el => el.value === this.form.kegiatan.programId).kode
      console.log(pro)
      this.form.kegiatan.kodeRUP = `${div}.${coa}-${jp}.${pro}`
    },
    tahunAnggaranSelChange() {
      this.getData()
      this.getProgramList()
    },
    programChange() {
      this.form.kegiatan.programId = this.program.selected.value
    },
    async getProgram(data) {
      let program = this.program.list.find(el => el.value === data);
      return program ? program.text : "";
    },
    getNumberSep: function(data) {
      return parseInt(data, 10).toLocaleString('de-DE')
    },
    // getStatus: function(data) {
    //   return data === 'N' ? 'Baru' : 'Paket'
    // },
    // getColorStatus: function(data) {
    //   return data === 'N' ? 'info' : 'success'
    // },

    getStatus: function(data) {
      let caption =''
      switch (data) {
        case 'AM':
          caption = 'Approve PPK'
          break
        case 'AP':
          caption = 'Approve Directorat'
          break
        case 'AU':
          caption = 'Proses Divisi Pengadaan'
          break
        case 'AD':
          caption = 'Approve Dirut'
          break
        case 'RM':
          caption = 'Reject PPK'
          break
        case 'RP':
          caption = 'Reject Directorat'
          break
        case 'RU':
          caption = 'Reject ULP'
          break
        case 'RD':
          caption = 'Reject Dirut'
          break
        case 'U':
          caption = 'Paket'
          break
        case 'D':
          caption = 'Draft'
          break
        default:
          caption = 'Baru'
      }
      return caption
    },
    getColorStatus: function(data) {
      let caption =''
      switch (data) {
        case 'D':
          caption = 'warning'
          break
        case 'AM': 
        case 'AP':
        case 'AU': 
        case 'AD':
          caption = 'success'
          break
        case 'RM':
        case 'RP':
        case 'RU':
        case 'RD':
          caption = 'error'
          break
        default:
          caption = 'info'
      }
      return caption
    },

    resetForm() {
        this.form.kegiatan = {
            id: "",
            kode: "",
            kodeRUP: "",
            nama: "",
            pagu: 0,
            paguTerpakai: 0,
            tahunAnggaran: this.tahunAnggaranSel,
            divisi: this.divisi,
            ppk: getPPKValue(this.divisi),
            volume: 0,
            pelaksanaanKontrakAwal: null,
            pelaksanaanKontrakAkhir: null,
            pelaksanaanPemilihanPenyediaAwal: null,
            pelaksanaanPemilihanPenyediaAkhir: null,
            status: 'N',
            programId: 0,   
            fk_jenisPengadaanId: 0,
            fk_metodePemilihanId: 0,   
            listPendanaan: [], 
        };
        this.formListPendanaan = [ { sumberDana: "", asalDana: "", mak: "", pagu: 0 } ];
        this.program.selected = { text: "", value: "", kode: "" }
    },

    async openForm(kegiatan, approve, view) {
      this.form.isView = view
      if (kegiatan)
      {
          if (kegiatan.status !== 'N' && !this.form.isView) {
            this.notification = {
                show: true,
                color: "warning",
                text: "Data kegiatan tidak bisa diubah, Sudah di-Approve/Reject"
            }
          } 
          else {              
            this.form.isEditing = !approve;
            this.form.kegiatan = Object.assign({}, kegiatan);

            const index = this.program.list.findIndex(element => { return element.value === kegiatan.programId; });

            if (index != -1)
            {
                this.program.selected = this.program.list[index];
            }

            await axios.get(apiUrl+`/api/rup/kegiatan/sumber-dana/${kegiatan.id}`)
            .then( (response) => {
                console.log("List sumber dana: ", response.data);
                this.formListPendanaan = response.data;
                this.updateTotalPagu();
            });

            this.form.isShowing = true;
          }
      }
      else
      {
          this.resetForm();
          // const currYY = new Date().getFullYear()
          // await axios.get(apiUrl+`/api/rup/numgen/kegiatan/${currYY}/0/none`)
          //   .then( (response) => {
          //       this.currNumber = response.data
          //       this.form.kegiatan.kode = `${currYY}-${this.currNumber}`
          //   });            
          this.form.isShowing = true;
      }
    },


    closeForm() {
        this.form.isShowing = false;
        this.form.isEditing = false;
        this.form.isDeleting = false;
        this.form.isView = false
    },


    deleteConfirmation(kegiatan) {
        if (kegiatan)
        {
            if (kegiatan.status !== 'N') {
              this.notification = {
                  show: true,
                  color: "warning",
                  text: "Data kegiatan tidak bisa dihapus, Sudah di-Approve/Reject"
              }
            } 
            else {
              this.form.kegiatan = kegiatan;
              this.form.isDeleting = true;
            }
        }
    },


    submitForm() {
        console.log(this.form.kegiatan);
        
        // Update
        if (this.form.isEditing)
        {
            this.form.kegiatan.listPendanaan = this.formListPendanaan;
            this.form.kegiatan.programId = this.program.selected.value;
            this.generateKode()
            this.submitting = true;

            axios.put(apiUrl+`/api/rup/kegiatan/${this.form.kegiatan.id}`, this.form.kegiatan)
            .then( (response) => {
              console.log(response)
              this.getData()
              // let index = this.table.items.findIndex(element => {
              //     return element.id == response.data.id;
              // });

              // if (index != -1)
              // {
              //     this.table.items.splice(index, 1, response.data);
              // }

              this.notification = {
                  show: true,
                  color: "success",
                  text: "Data kegiatan berhasil di-update"
              }
            })
            .catch( (error) => {
                this.notification = {
                    show: true,
                    color: "error",
                    text: `[${error.message}] Gagal meng-update data kegiatan`
                }
            })
            .finally( () => {
              this.submitting = false;
            });
        }
        // Delete
        else if (this.form.isDeleting)
        {
            this.submitting = true;

            axios.delete(apiUrl+`/api/rup/kegiatan/${this.form.kegiatan.id}`)
            .then( (response) => {
              console.log(response)
              this.getData()
              // let index = this.table.items.findIndex(element => {
              //     return element.id == response.data.id;
              // });

              // if (index != -1)
              // {
              //     this.table.items.splice(index, 1);
              // }

              this.notification = {
                  show: true,
                  color: "success",
                  text: "Data kegiatan berhasil dihapus"
              }
              this.form.isDeleting = false
            })
            .catch( (error) => {
                this.notification = {
                    show: true,
                    color: "error",
                    text: `[${error.message}] Gagal menghapus data kegiatan`
                }
            })
            .finally( () => {
              this.submitting = false;
            });
        }
        // Create
        else
        {
            this.form.kegiatan.listPendanaan = this.formListPendanaan;        
            this.generateKode();
            this.submitting = true;

            axios.post(apiUrl+"/api/rup/kegiatan", this.form.kegiatan)
            .then( (response) => {
              console.log(response)
              this.getData()
              this.notification = {
                  show: true,
                  color: "success",
                  text: "Data kegiatan berhasil ditambahkan"
              }
            })
            .catch( (error) => {
                this.notification = {
                    show: true,
                    color: "error",
                    text: `[${error.message}] Gagal menambahkan data kegiatan`
                };
            })
            .finally( () => {
              this.submitting = false;
            });
        }

        this.closeForm();
    },

    Approve(approve) {
          let textmsg = ''
          if (approve) {
            this.form.kegiatan.status = 'AM'
            textmsg = "Data kegiatan berhasil di-approve"
          }
          else {
            if (this.form.kegiatan.manAlasan === "" || this.form.kegiatan.manAlasan === null) {
              this.notification = {
                  show: true,
                  color: "error",
                  text: 'Alasan reject harus diisi !'
              }
              return
            }
            this.form.kegiatan.status = 'RM'
            textmsg = "Data kegiatan berhasil di-reject"
          }
          this.form.kegiatan.listPendanaan = this.formListPendanaan;
          this.form.kegiatan.programId = this.program.selected.value;
          this.form.kegiatan.manUser = this.userId;
          this.submitting = true;

          axios.put(apiUrl+`/api/rup/kegiatan/sup/${this.form.kegiatan.id}`, this.form.kegiatan)
          .then( (response) => {
              let index = this.table.items.findIndex(element => {
                  return element.id == response.data.id;
              });

              if (index != -1)
              {
                  this.table.items.splice(index, 1, response.data);
              }

              this.notification = {
                  show: true,
                  color: "success",
                  text: textmsg
              }
          })
          .catch( (error) => {
              this.notification = {
                  show: true,
                  color: "error",
                  text: `[${error.message}] Gagal approve data kegiatan`
              }
          })
          .finally( () => {
            this.submitting = false;
          });
          

          this.closeForm();
      },


    updateTotalPagu() {
        this.form.kegiatan.pagu = 0;
        this.formListPendanaan.forEach(element => {
            this.form.kegiatan.pagu += Number(element.pagu);
        });
    },
    addSumberDana() {
        this.formListPendanaan.push( { sumberDana: "", asalDana: "", mak: "", pagu: 0 } );
    },
    removeSumberDana(event, index) {
        const currentLength = this.formListPendanaan.length;

        if (currentLength > 1 && index >= 0 && index < currentLength)
        {
            this.form.kegiatan.pagu -= Number(this.formListPendanaan[index].pagu);
            this.formListPendanaan.splice(index, 1);
        }
    },

    exportXls: async function() {
      // await axios.get(`${apiUrl}/api/rup/xls/kegiatan/${this.divisi}`)
      await axios.get(`${apiUrl}/api/rup/xls/kegiatan/div/${this.divisi}/tahun/${this.tahunAnggaranSel}`)
      .then(response => {
        this.getLinkDownload(response.data.file)
      })
      .catch(error => {
        console.log(error.response.data.message)
      })
    },

    exportPdf: async function() {
      await axios.get(`${apiUrl}/api/rup/pdf/kegiatan/${this.divisi}`)
      .then(response => {
        this.getLinkDownload(response.data.file)
      })
      .catch(error => {
        console.log(error.response.data.message)
      })
    },

    getLinkDownload: async function(dok) {
      await axios.get(`${apiUrl}/${dok}`, { responseType: 'blob' })
      .then(response => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = dok
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
    },
    getDateFormattedDatefns: function(date) {
      return date ? format(Date.parse(date), "dd MMM yyyy HH:mm") : ''
    },
  }

}
</script>

<style scoped>
.rightalign >>> input {
  text-align: right;
}

.container{
  max-width: 100vw;
  padding:0px;
}

</style>